<template lang="pug">
  v-container.postal-container.mt-2.pa-0(fluid)
    v-container.postal-victim.pa-0(fluid justify-center :id="'victim' + victimData.victimFolio")
      v-container.postal.px-0.mt-3.pb-0(fluid)
        v-layout.header(row wrap)
          v-flex.pb-2(d-flex xs12 sm5)
            v-layout(column)
              v-flex(d-flex xs1)
                .justify-center.align-center(d-flex)
                  img.info(src="/static/logo.jpeg")
          v-flex.pb-2(d-flex xs12 sm7)
            v-layout(column)
              v-flex(d-flex xs12)
                .fill
                  v-flex(d-flex xs12 fill-height align-center)
                    h1.head.title {{victimData.disappearancePlace ? victimData.disappearancePlace : 'Entidad'}}
                    p.head.subtitle.dark-text.pl-2.mr-3(fill-height align-center) Folio {{'#' + victimData.visibleFolio}}
        v-layout.pl-3.pr-3.pt-1.aggression(row wrap d-flex fill-height align-content-center)
          v-flex.mt-3(d-flex xs5)
            v-layout(column)
              v-flex.mb-3(d-flex xs12)
                .pr-2(d-flex)
                  img.mt-3.victim-photo(width="100%" title="Cambiar imagen" alt="profile img" v-if="(photo != '')" :src="photo") 
                  img.mt-3.victim-photo(width="100%" title="Cambiar imagen" alt="profile img" v-else src="static/upload-icon.png")
  
          v-flex.pl-3(xs7 align-center)
            v-layout.mx-0.where(row wrap justify-center)
              v-flex.border.pl-2(d-flex xs11)
                .fill-height.align-center.text-xs-center.d-flex
                  v-card-text.pt-0.pb-0
                    p.black-content-title-victim {{victimData.victimName}}
              v-flex.pl-2(d-flex xs12)
                .fill-height.align-center.text-xs-center.d-flex
                  v-card-text.pt-0.pb-1
                    p.info-title Nombre de la víctima
                      v-layout.mx-0.where(row wrap)

            v-layout.mx-0.where(row wrap justify-center)
              v-flex.border.pl-2(d-flex xs10)
                .fill-height.align-center.text-xs-center.d-flex
                  v-card-text.pt-0.pb-0
                    p.content-title-victim {{dateFormattedMomentjs(victimData.lastSeenDate)}}
              v-flex.pl-2(d-flex xs12)
                .fill-height.align-center.text-xs-center.d-flex
                  v-card-text.pt-0.pb-1
                    p.info-title Fecha de último avistamiento
                      v-layout.mx-0.where(row wrap)
                        
            v-layout.mx-0.where(row wrap justify-center)
              v-flex.border.pl-2(d-flex xs9)
                .fill-height.align-center.text-xs-center.d-flex
                  v-card-text.pt-0.pb-0
                    p.content-title-victim {{victimData.municipality && victimData.municipality.lenght > 22 ? victimData.municipality.substr(0,19) + '...' : victimData.municipality}} {{victimData.municipality ? ',' : ''}} {{victimData.disappearancePlace ? victimData.disappearancePlace : ''}}
              v-flex.pl-2(d-flex xs12)
                .fill-height.align-center.text-xs-center.d-flex
                  v-card-text.pt-0.pb-1
                    p.info-title Lugar de los hechos
                      v-layout.mx-0.where(row wrap)

            v-layout.mx-0.where(row wrap justify-center)
              v-flex.border(d-flex xs8)
                .fill-height.align-center.text-xs-center.d-flex
                  v-card-text.pa-0
                    p.black-content-title-victim {{victimData.status}}
              v-flex(d-flex xs12)
                .fill-height.align-center.text-xs-center.d-flex
                  v-card-text.px-0.pt-0.pb-1
                    p.info-title Estatus de localización
                      v-layout.mx-0.where(row wrap)

        v-layout(row wrap)
          v-flex(d-flex xs12)
            v-layout.my-0(row wrap)
              v-flex(d-flex xs5)
                v-layout.mx-0.where(row wrap justify-center)
                  v-flex.border(d-flex xs12)
                    .fill-height.align-center.text-xs-center.d-flex
                      v-card-text.pa-0
                        p.black-content-title {{victimData.age ? victimData.age + ' años' : ''}}  
                  v-flex(d-flex xs12)
                    .fill-height.align-center.text-xs-center.d-flex
                      v-card-text.px-0.pt-0.pb-1
                        p.info-title Edad
                          v-layout.mx-0.where(row wrap)
              v-flex.pl-3(xs7 align-center)
                v-layout.mx-0.where(row wrap justify-center)
                  v-flex.border(d-flex xs11)
                    .fill-height.align-center.text-xs-center.d-flex
                      v-card-text.pa-0
                        p.black-content-title {{victimData.nationality ? victimData.nationality : ''}}
                  v-flex(d-flex xs11)
                    .fill-height.align-center.text-xs-center.d-flex
                      v-card-text.px-0.pt-0.pb-1
                        p.info-title Nacionalidad
                          v-layout.mx-0.where(row wrap)

          v-flex(d-flex xs12)
            v-layout.details.m-0(row wrap)
              v-flex.my-0(xs12)
                p.details-title.px-4.bold.pt-1.pb-0 Descripción Física
              v-flex.my-0(xs12)
                p.details-box {{victimData.physicalDescription}}


          v-flex(d-flex xs12)
            v-layout.details.m-0(row wrap)
              v-flex.my-0(xs12)
                p.details-title.px-4.bold.pt-1.pb-0 Descripción de los hechos
              v-flex.my-0(xs12)
                p.details-box {{victimData.factDescription}}

          v-flex.mb-2.mxh-40(d-flex xs12)
            .fill-height.align-center.text-xs-center.d-flex
              v-card-text.pa-0
                p.info-text Cualquier información comunicarse a:
          v-flex.mxh-70(d-flex xs12)
            .fill-height.align-center.text-xs-center.d-flex
              v-card-text.px-0.pt-0.pb-1
                p.contact 01 (844) 412 37 84 ext. 124/125
                p.contact comunicación@frayjuandelarios.org

</template>

<script>
import moment from "moment";

export default {
  name: "Postal",
  props: ['victimData'],
  computed: {
    path() {
      return this.$router.currentRoute.path;
    },
    photo() {
      let victimForm = this.findVictim(this.victimData.victimFolio);
      return victimForm.photo;
    },
  },
  methods: {
    dateFormattedMomentjs (value) {
      return value ? moment(value).format('DD/MM/YYYY') : '';
    },
    findVictim(folio) {
      return _.find(this.$store.state.victims, (d) => d.victimFolio === folio);
    },
  },
};
</script>

<style src="./postal.scss" lang="scss">
</style>
